export default "__VITE_ASSET__DvdamIUP__"